export default __webpack_public_path__ + "static/media/check-greem.2b9b2a0e.svg";